export enum DeliveryType {
  IssuePoint = 1,
  RussianPost = 2,
}

export interface RegisterCardApplicationRequestPayload {
  accessToken?: string | null;
  counterpartyDepartmentId: number;
  deliveryTypeId: DeliveryType;
  desiredAddress?: string;
  agentInfo?: {
    firstName: string;
    lastName: string;
    middleName: string;
    document: string;
    passport: string;
    parentAccountId?: number | null | undefined;
  };
}
